"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IA = void 0;
const gl_matrix_1 = require("gl-matrix");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const echain_shared_2d_shapes_1 = require("@igus/echain-shared-2d-shapes");
const Article_1 = require("../Article");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const IARef_1 = require("./IARef");
const StaticIA_1 = require("./StaticIA");
const echain_product_models_1 = require("@igus/echain-product-models");
class IA extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'IA';
    }
    get artikeltyp() {
        return this.model.Artikeltyp;
    }
    set artikeltyp(value) {
        this.model.Artikeltyp = value;
    }
    get bestTyp() {
        return this.model.BestTyp;
    }
    set bestTyp(value) {
        this.model.BestTyp = value;
    }
    get ketteSerieRef() {
        var _a;
        return (_a = this.model.KetteSerieRef) === null || _a === void 0 ? void 0 : _a.map((v) => ({
            id: v.Id,
            kuerzel: v.Kuerzel,
            artikeltyp: v.Artikeltyp,
        }));
    }
    set ketteSerieRef(values) {
        this.model.KetteSerieRef = values
            ? values.map((v) => ({
                Id: v.id,
                Kuerzel: v.kuerzel,
                Artikeltyp: v.artikeltyp,
            }))
            : [];
    }
    get ketteRef() {
        return this.model.KetteRef;
    }
    set ketteRef(value) {
        this.model.KetteRef = value;
    }
    get kind() {
        return this.model.Kind;
    }
    set kind(value) {
        this.model.Kind = value;
    }
    get breite() {
        return echain_shared_quantities_1.Q.optional(this.model.Breite);
    }
    set breite(value) {
        this.model.Breite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get montiert() {
        return this.model.Montiert;
    }
    set montiert(value) {
        this.model.Montiert = value;
    }
    get color() {
        return this.model.Color;
    }
    set color(value) {
        this.model.Color = value;
    }
    get material() {
        return this.model.Material;
    }
    set material(value) {
        this.model.Material = value;
    }
    get perNthKettenglied() {
        return this.model.PerNthKettenglied;
    }
    set perNthKettenglied(value) {
        this.model.PerNthKettenglied = value;
    }
    get startingAtNthKettenglied() {
        return this.model.StartingAtNthKettenglied;
    }
    set startingAtNthKettenglied(value) {
        this.model.StartingAtNthKettenglied = value;
    }
    get montagehinweis() {
        return this.model.Montagehinweis;
    }
    set montagehinweis(value) {
        this.model.Montagehinweis = value;
    }
    get iaRef() {
        var _a;
        return (_a = this.model.IARef) === null || _a === void 0 ? void 0 : _a.map((v) => new IARef_1.IARef(v));
    }
    set iaRef(value) {
        this.model.IARef = value === null || value === void 0 ? void 0 : value.map((v) => v.model);
    }
    get gewicht() {
        return echain_shared_quantities_1.Q.optional(this.model.Gewicht);
    }
    set gewicht(value) {
        this.model.Gewicht = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get manualCount() {
        return this.model.ManualCount;
    }
    set manualCount(value) {
        this.model.ManualCount = value;
    }
    get aussenbreite() {
        return echain_shared_quantities_1.Q.optional(this.model.Aussenbreite);
    }
    set aussenbreite(value) {
        this.model.Aussenbreite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get aussenhoehe() {
        return echain_shared_quantities_1.Q.optional(this.model.Aussenhoehe);
    }
    set aussenhoehe(value) {
        this.model.Aussenhoehe = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get innenbreite() {
        return echain_shared_quantities_1.Q.optional(this.model.Innenbreite);
    }
    set innenbreite(value) {
        this.model.Innenbreite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get innenhoehe() {
        return echain_shared_quantities_1.Q.optional(this.model.Innenhoehe);
    }
    set innenhoehe(value) {
        this.model.Innenhoehe = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get fussbreite() {
        return echain_shared_quantities_1.Q.optional(this.model.Fussbreite);
    }
    set fussbreite(value) {
        this.model.Fussbreite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get artNrConnect() {
        return this.model.ArtNrConnect;
    }
    set artNrConnect(value) {
        this.model.ArtNrConnect = value;
    }
    get artNrIntersect() {
        return this.model.ArtNrIntersect;
    }
    set artNrIntersect(value) {
        this.model.ArtNrIntersect = value;
    }
    get artyConnect() {
        return this.model.ArtyConnect;
    }
    set artyConnect(value) {
        this.model.ArtyConnect = value;
    }
    get artyIntersect() {
        return this.model.ArtyIntersect;
    }
    set artyIntersect(value) {
        this.model.ArtyIntersect = value;
    }
    get iaBodenH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IABodenH);
    }
    set iaBodenH(value) {
        this.model.IABodenH = value.quantity;
    }
    get iaHKB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKB);
    }
    set iaHKB(value) {
        this.model.IAHKB = value.quantity;
    }
    get iaHKBOT() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKBOT);
    }
    set iaHKBOT(value) {
        this.model.IAHKBOT = value.quantity;
    }
    get iaHKDist() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKDist);
    }
    set iaHKDist(value) {
        this.model.IAHKDist = value.quantity;
    }
    get iaHKH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKH);
    }
    set iaHKH(value) {
        this.model.IAHKH = value.quantity;
    }
    get iaHKHeight() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKHeight);
    }
    set iaHKHeight(value) {
        this.model.IAHKHeight = value.quantity;
    }
    get iaHKOLB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLB);
    }
    set iaHKOLB(value) {
        this.model.IAHKOLB = value.quantity;
    }
    get iaHKOLOB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLOB);
    }
    set iaHKOLOB(value) {
        this.model.IAHKOLOB = value.quantity;
    }
    get iaHKOLOH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLOH);
    }
    set iaHKOLOH(value) {
        this.model.IAHKOLOH = value.quantity;
    }
    get iaHKOLUB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLUB);
    }
    set iaHKOLUB(value) {
        this.model.IAHKOLUB = value.quantity;
    }
    get iaHKOLUH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLUH);
    }
    set iaHKOLUH(value) {
        this.model.IAHKOLUH = value.quantity;
    }
    get iaHKOLUHRounded() {
        return this.model.IAHKOLUH_Rounded;
    }
    set iaHKOLUHRounded(value) {
        this.model.IAHKOLUH_Rounded = value;
    }
    get iaHKORB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKORB);
    }
    set iaHKORB(value) {
        this.model.IAHKORB = value.quantity;
    }
    get iaHKOROB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOROB);
    }
    set iaHKOROB(value) {
        this.model.IAHKOROB = value.quantity;
    }
    get iaHKORUB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKORUB);
    }
    set iaHKORUB(value) {
        this.model.IAHKORUB = value.quantity;
    }
    get iaHKRep() {
        return this.model.IAHKRep;
    }
    set iaHKRep(value) {
        this.model.IAHKRep = value;
    }
    get iaHKULB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULB);
    }
    set iaHKULB(value) {
        this.model.IAHKULB = value.quantity;
    }
    get iaHKULOB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULOB);
    }
    set iaHKULOB(value) {
        this.model.IAHKULOB = value.quantity;
    }
    get iaHKULOH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULOH);
    }
    set iaHKULOH(value) {
        this.model.IAHKULOH = value.quantity;
    }
    get iaHKULOHRounded() {
        return this.model.IAHKULOH_Rounded;
    }
    set iaHKULOHRounded(value) {
        this.model.IAHKULOH_Rounded = value;
    }
    get iaHKULUB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULUB);
    }
    set iaHKULUB(value) {
        this.model.IAHKULUB = value.quantity;
    }
    get iaHKULUH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULUH);
    }
    set iaHKULUH(value) {
        this.model.IAHKULUH = value.quantity;
    }
    get iaHKURB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKURB);
    }
    set iaHKURB(value) {
        this.model.IAHKURB = value.quantity;
    }
    get iaHKUROB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKUROB);
    }
    set iaHKUROB(value) {
        this.model.IAHKUROB = value.quantity;
    }
    get iaHKURUB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKURUB);
    }
    set iaHKURUB(value) {
        this.model.IAHKURUB = value.quantity;
    }
    get iaKisteHO() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAKisteHO);
    }
    set iaKisteHO(value) {
        this.model.IAKisteHO = value.quantity;
    }
    get iaKisteHU() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAKisteHU);
    }
    set iaKisteHU(value) {
        this.model.IAKisteHU = value.quantity;
    }
    get iaUebermass() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAUebermass);
    }
    set iaUebermass(value) {
        this.model.IAUebermass = value.quantity;
    }
    get iaWmm() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAwmm);
    }
    set iaWmm(value) {
        this.model.IAwmm = value.quantity;
    }
    get localTransform() {
        return this.model.LocalTransform;
    }
    get localTransformPosition() {
        return this.localTransform
            ? {
                x: this.localTransform[4],
                y: this.localTransform[5],
            }
            : undefined;
    }
    set localTransform(value) {
        this.model.LocalTransform = value;
    }
    get innerContours() {
        var _a;
        return (_a = this.model.InnerContours) === null || _a === void 0 ? void 0 : _a.map((v) => echain_shared_2d_shapes_1.Contour.fromJson(v));
    }
    set innerContours(value) {
        this.model.InnerContours = value === null || value === void 0 ? void 0 : value.map((v) => v.toJson());
    }
    get triangles() {
        var _a;
        return (_a = this.model.Triangles) === null || _a === void 0 ? void 0 : _a.map((v) => echain_shared_2d_shapes_1.Triangle.fromJson(v));
    }
    set triangles(value) {
        this.model.Triangles = value === null || value === void 0 ? void 0 : value.map((v) => v.toJson());
    }
    get _iaIndex() {
        return this.model.IAIndex;
    }
    set _iaIndex(value) {
        this.model.IAIndex = value;
    }
    static fromScratch() {
        return new IA({
            ArticleType: echain_product_models_1.ArticleType.ia,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            IABodenH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKBOT: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKDist: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKHeight: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLOB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLOH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLUB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLUH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLUH_Rounded: false,
            IAHKORB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOROB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKORUB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKRep: 0,
            IAHKULB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKULOB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKULOH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKULOH_Rounded: false,
            IAHKULUB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKULUH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKURB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKUROB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKURUB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAKisteHO: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAKisteHU: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAUebermass: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAwmm: echain_shared_quantities_1.Q.Length.mm(0).quantity,
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'IA.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        args.ArtNrExists = true;
        args.ArtNrGenerated = echain_shared_articles_1.ArticleArtNrUtils.artNr(args.ArtNr);
        return IA.fromJson(args, cloneStrategy);
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'IA.fromInventedArtNrArgs: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const ia = IA.fromJson(args, cloneStrategy);
        ia.artNrExists = false;
        return ia;
    }
    static fromJson(args, cloneStrategy = 'deep') {
        const ia = IA.fromScratch();
        ia.fromJson(args, cloneStrategy);
        return ia;
    }
    static fromModel(model) {
        const ia = IA.fromScratch();
        Object.assign(ia.model, model);
        Object.assign(model, ia.model);
        ia.model = model;
        return ia;
    }
    /**
     * Generates an ArtNr
     *
     * @param artNr The base artNr for generation
     * @param color The color to encode in the artNr
     * @param material The material to encode in the artNr
     * @returns The generated artNr.
     */
    static generateArtNr(artNrCountry, artNr, color, material) {
        let artNrGenerated = artNr;
        if (color !== '0')
            artNrGenerated += `${echain_shared_i18n_1.LocaleUtil.getArtNrSeparator(artNrCountry)}${color}`;
        if (material)
            artNrGenerated += `${echain_shared_i18n_1.LocaleUtil.getArtNrSeparator(artNrCountry)}${material}`;
        return artNrGenerated;
    }
    /** Getter: gets the iaIndex prepended with 'S' */
    get iaIndex() {
        if (this._iaIndex == null) {
            return undefined;
        }
        return 'S' + this._iaIndex;
    }
    /** Setter: sets the iaIndex. Will prepend 'S' if not already done. */
    set iaIndex(value) {
        this.setIAIndex(value);
    }
    /** Gets the IAIndex as number */
    getIAIndexAsNumber() {
        if (this._iaIndex == null) {
            return undefined;
        }
        else {
            return parseInt(this._iaIndex, 10);
        }
    }
    /** Sets the iaIndex. Can be set via number or string, either prepended with 'S' or not. */
    setIAIndex(value) {
        if (value == null)
            this._iaIndex = undefined;
        else if (typeof value === 'number')
            this._iaIndex = value.toString();
        else if (value.indexOf('S') === 0)
            this._iaIndex = value.substring(1);
        else
            this._iaIndex = value;
    }
    isConnectAllowed(ia) {
        let isArtNrConnect = false;
        if (this.artNrConnect) {
            const articleNumberStarts = this.artNrConnect.split('|');
            articleNumberStarts.forEach((articleNumberStart) => {
                let articleNumberPart = articleNumberStart.trim();
                articleNumberPart =
                    articleNumberPart.charAt(articleNumberPart.length - 1) === '.' ? articleNumberPart : articleNumberPart + '.';
                isArtNrConnect = isArtNrConnect || ia.isReferencedByArtNrStart(articleNumberPart);
            });
        }
        if (this.artyConnect && !isArtNrConnect) {
            const articleTypes = this.artyConnect.split('|');
            articleTypes.forEach((articleType) => {
                isArtNrConnect = isArtNrConnect || ia.artikeltyp === parseInt(articleType.trim(), 10);
            });
        }
        return isArtNrConnect;
    }
    isIntersectAllowed(ia) {
        let isArtNrIntersect = false;
        if (this.artNrIntersect) {
            const articleNumberStarts = this.artNrIntersect.split('|');
            articleNumberStarts.forEach((articleNumberStart) => {
                let articleNumberPart = articleNumberStart.trim();
                articleNumberPart =
                    articleNumberPart.charAt(articleNumberPart.length - 1) === '.' ? articleNumberPart : articleNumberPart + '.';
                isArtNrIntersect = isArtNrIntersect || ia.isReferencedByArtNrStart(articleNumberPart);
            });
        }
        if (this.artyIntersect && !isArtNrIntersect) {
            const articleTypes = this.artyIntersect.split('|');
            articleTypes.forEach((articleType) => {
                isArtNrIntersect = isArtNrIntersect || ia.artikeltyp === parseInt(articleType.trim(), 10);
            });
        }
        return isArtNrIntersect;
    }
    static isTrennsteg(artikeltyp) {
        return [
            echain_shared_articles_1.IAArtikeltyp.Hoehenschlitzsteg,
            echain_shared_articles_1.IAArtikeltyp.HoehenschlitzstegOffen,
            echain_shared_articles_1.IAArtikeltyp.KlemmRasttrennsteg,
            echain_shared_articles_1.IAArtikeltyp.Klemmteilungssteg,
            echain_shared_articles_1.IAArtikeltyp.Klemmtrennsteg,
            echain_shared_articles_1.IAArtikeltyp.KlemmtrennstegAsymetrisch,
            echain_shared_articles_1.IAArtikeltyp.KlemmtrennstegHoehenschlitz,
            echain_shared_articles_1.IAArtikeltyp.Rasttrennsteg,
            echain_shared_articles_1.IAArtikeltyp.Teilungssteg,
            echain_shared_articles_1.IAArtikeltyp.Trennsteg,
            echain_shared_articles_1.IAArtikeltyp.TrennstegAsymetrisch,
            echain_shared_articles_1.IAArtikeltyp.TrennstegGeschlitzt,
            echain_shared_articles_1.IAArtikeltyp.TrennstegMitZwischenboden,
            echain_shared_articles_1.IAArtikeltyp.Universalraststeg,
            echain_shared_articles_1.IAArtikeltyp.Universalsteg,
            echain_shared_articles_1.IAArtikeltyp.Zugentlastungstrennsteg,
        ].includes(artikeltyp);
    }
    isTrennsteg() {
        return Boolean(this.artikeltyp && IA.isTrennsteg(this.artikeltyp));
    }
    static isFachboden(artikeltyp) {
        return [
            echain_shared_articles_1.IAArtikeltyp.Einsteckboden,
            echain_shared_articles_1.IAArtikeltyp.Fachboden,
            echain_shared_articles_1.IAArtikeltyp.Universalboden,
            echain_shared_articles_1.IAArtikeltyp.Zwischenboden,
        ].includes(artikeltyp);
    }
    isFachboden() {
        return Boolean(this.artikeltyp && IA.isFachboden(this.artikeltyp));
    }
    static isAbstandhalter(artikeltyp) {
        return [echain_shared_articles_1.IAArtikeltyp.Abstandhalter, echain_shared_articles_1.IAArtikeltyp.Rollenclip].includes(artikeltyp);
    }
    isAbstandhalter() {
        return Boolean(this.artikeltyp && IA.isAbstandhalter(this.artikeltyp));
    }
    static isSeitenplatte(artikeltyp) {
        return artikeltyp === echain_shared_articles_1.IAArtikeltyp.Seitenplatte;
    }
    isSeitenplatte() {
        return Boolean(this.artikeltyp && IA.isSeitenplatte(this.artikeltyp));
    }
    static isRaststeg(artikeltyp) {
        return [echain_shared_articles_1.IAArtikeltyp.KlemmRasttrennsteg, echain_shared_articles_1.IAArtikeltyp.Rasttrennsteg, echain_shared_articles_1.IAArtikeltyp.Universalraststeg].includes(artikeltyp);
    }
    isRaststeg() {
        return Boolean(this.artikeltyp && IA.isRaststeg(this.artikeltyp));
    }
    static isHoehenschlitzsteg(artikeltyp) {
        return [
            echain_shared_articles_1.IAArtikeltyp.Hoehenschlitzsteg,
            echain_shared_articles_1.IAArtikeltyp.HoehenschlitzstegOffen,
            echain_shared_articles_1.IAArtikeltyp.KlemmtrennstegHoehenschlitz,
        ].includes(artikeltyp);
    }
    isHoehenschlitzsteg() {
        return Boolean(this.artikeltyp && IA.isHoehenschlitzsteg(this.artikeltyp));
    }
    /**
     * Test if the IA is a ring.
     */
    isRing() {
        var _a;
        const artNrDe = (_a = this.localizedArtNr) === null || _a === void 0 ? void 0 : _a['DE'];
        if (artNrDe) {
            return Boolean(echain_shared_articles_1.ringIAsData.find((iaData) => artNrDe === iaData.artNr));
        }
        return false;
    }
    /**
     * Test if it might have a flexible width.
     */
    isFlexWidth() {
        return Boolean(this.artikeltyp &&
            [echain_shared_articles_1.IAArtikeltyp.Fachboden, echain_shared_articles_1.IAArtikeltyp.Universalboden, echain_shared_articles_1.IAArtikeltyp.Zwischenboden].includes(this.artikeltyp));
    }
    /**
     * Test if the given IA is a horizontal IA.
     */
    isHorizontal() {
        return Boolean(this.artikeltyp &&
            [
                echain_shared_articles_1.IAArtikeltyp.Einsteckboden,
                echain_shared_articles_1.IAArtikeltyp.Fachboden,
                echain_shared_articles_1.IAArtikeltyp.Universalboden,
                echain_shared_articles_1.IAArtikeltyp.Zwischenboden,
            ].includes(this.artikeltyp));
    }
    /**
     * Test if the given IA is a vertical IA.
     */
    isVertical() {
        return Boolean(this.artikeltyp &&
            !this.isUniversalSeparator() &&
            [
                echain_shared_articles_1.IAArtikeltyp.Hoehenschlitzsteg,
                echain_shared_articles_1.IAArtikeltyp.HoehenschlitzstegOffen,
                echain_shared_articles_1.IAArtikeltyp.KlemmRasttrennsteg,
                echain_shared_articles_1.IAArtikeltyp.Klemmteilungssteg,
                echain_shared_articles_1.IAArtikeltyp.Klemmtrennsteg,
                echain_shared_articles_1.IAArtikeltyp.KlemmtrennstegAsymetrisch,
                echain_shared_articles_1.IAArtikeltyp.KlemmtrennstegHoehenschlitz,
                echain_shared_articles_1.IAArtikeltyp.Rasttrennsteg,
                echain_shared_articles_1.IAArtikeltyp.Seitenplatte,
                echain_shared_articles_1.IAArtikeltyp.Teilungssteg,
                echain_shared_articles_1.IAArtikeltyp.Trennsteg,
                echain_shared_articles_1.IAArtikeltyp.TrennstegAsymetrisch,
                echain_shared_articles_1.IAArtikeltyp.TrennstegGeschlitzt,
                echain_shared_articles_1.IAArtikeltyp.TrennstegMitZwischenboden,
                echain_shared_articles_1.IAArtikeltyp.Universalraststeg,
                echain_shared_articles_1.IAArtikeltyp.Universalsteg,
            ].includes(this.artikeltyp) &&
            !this.isRing());
    }
    isUniversalSeparator() {
        return this.artikeltyp === echain_shared_articles_1.IAArtikeltyp.UniversalSeparator;
    }
    isSmartPlasticsSeparator() {
        return this.artikeltyp === echain_shared_articles_1.IAArtikeltyp.SmartPlasticsSeparator;
    }
    isTeilungssteg() {
        return Boolean(this.artikeltyp && [echain_shared_articles_1.IAArtikeltyp.Teilungssteg, echain_shared_articles_1.IAArtikeltyp.Klemmteilungssteg].includes(this.artikeltyp));
    }
    /**
     * Tests if the IA can be placed inside a Kette
     */
    isPlaceable() {
        return this.isVertical() || this.isHorizontal() || this.isRing();
    }
    fromJson(json, cloneStrategy = 'deep') {
        var _a;
        super.fromJson(json, cloneStrategy);
        const artNrDe = (_a = this.localizedArtNr) === null || _a === void 0 ? void 0 : _a['DE'];
        if (artNrDe) {
            // patch ring IA data into IA instance
            const ringIaData = echain_shared_articles_1.ringIAsData.find((iaData) => iaData.artNr === artNrDe);
            if (ringIaData) {
                this.aussenbreite = echain_shared_quantities_1.Length.mm(ringIaData.aussenbreite_mm);
                this.aussenhoehe = echain_shared_quantities_1.Length.mm(ringIaData.aussenhoehe_mm);
                this.innenbreite = echain_shared_quantities_1.Length.mm(ringIaData.innenbreite_mm);
                this.innenhoehe = echain_shared_quantities_1.Length.mm(ringIaData.innenhoehe_mm);
            }
            // patch rx-tube ia's
            const iaPatches = echain_shared_articles_1.rxRohrIaPatches.find((iap) => iap.artNr === artNrDe);
            if (iaPatches) {
                this.iaHKH = echain_shared_quantities_1.Length.mm(iaPatches.IAHKH_mm);
                this.iaHKULUH = echain_shared_quantities_1.Length.mm(iaPatches.iaHKULUH_mm);
                this.iaHKOLOH = echain_shared_quantities_1.Length.mm(iaPatches.iaHKOLOH_mm);
            }
            // could be that this property is not defined, set it to zero at least!
            if (this.isOeffnungsSteg() && !this.iaUebermass) {
                this.iaUebermass = echain_shared_quantities_1.Length.mm(0);
            }
        }
    }
    clone() {
        return this._clone(IA.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    setIaBeat(beat) {
        this.startingAtNthKettenglied = beat === null || beat === void 0 ? void 0 : beat.startingAt;
        this.perNthKettenglied = beat === null || beat === void 0 ? void 0 : beat.perNth;
        return this;
    }
    hasIaBeat(beat) {
        return this.startingAtNthKettenglied === beat.startingAt && this.perNthKettenglied === beat.perNth;
    }
    /**
     * Get the max width of each side of the Trennsteg in the order:
     * leftTopWidth, rightTopWidth, leftBottomWidth, rightBottomWidth
     */
    upperAndLowerMaxWidths() {
        if (this.iaHKB && this.iaHKOLB && this.iaHKORB && this.iaHKULB && this.iaHKURB) {
            const halfMiddleWidth = this.iaHKB.mm * 0.5;
            const leftTopWidth = this.iaHKOLB.mm + halfMiddleWidth;
            const rightTopWidth = this.iaHKORB.mm + halfMiddleWidth;
            const leftBottomWidth = this.iaHKULB.mm + halfMiddleWidth;
            const rightBottomWidth = this.iaHKURB.mm + halfMiddleWidth;
            return gl_matrix_1.vec4.fromValues(leftTopWidth, rightTopWidth, leftBottomWidth, rightBottomWidth);
        }
        throw new Error(`IA.upperAndLowerMaxWidths: missing properties`);
    }
    /**
     * Should the IA element be placed upside down inside the Kette.
     */
    isPlaceUpsideDown(kette) {
        if (kette.noSeparaterFootBottom || kette.noSeparaterFootTop) {
            const widths = this.upperAndLowerMaxWidths();
            const upperWidth = widths[0] + widths[1];
            const lowerWidth = widths[2] + widths[3];
            if (upperWidth < lowerWidth && kette.noSeparaterFootBottom) {
                return true;
            }
            else if (upperWidth > lowerWidth && kette.noSeparaterFootTop) {
                return true;
            }
        }
        return false;
    }
    /**
     * Retrieves whether flipping for both directions are allowed or not.
     * Considers an optional given Kette which might force an IA to not being flippable.
     */
    isFlippingAllowed(kette) {
        let canFlipX = false;
        let canFlipY = false;
        if (this.isVertical()) {
            const iaWidths = this.upperAndLowerMaxWidths();
            const maxDist = 0.001;
            if (this.artikeltyp !== echain_shared_articles_1.IAArtikeltyp.Seitenplatte) {
                canFlipX = Math.abs(iaWidths[0] - iaWidths[1]) > maxDist || Math.abs(iaWidths[2] - iaWidths[3]) > maxDist;
            }
            canFlipY = Math.abs(iaWidths[0] - iaWidths[2]) > maxDist || Math.abs(iaWidths[1] - iaWidths[3]) > maxDist;
            if (kette && (kette.noSeparaterFootBottom || kette.noSeparaterFootTop)) {
                canFlipY = false;
            }
        }
        return { canFlipX, canFlipY };
    }
    /**
     * Retrieves StaticIA parts belonging to this IA.
     * We use this i.e. for RingIAs to build the internal structure for placing HorizontalIAs.
     */
    getStaticIaParts() {
        const ringIaData = echain_shared_articles_1.ringIAsData.find((iaData) => iaData.artNr === this.artNr);
        if (ringIaData && Array.isArray(ringIaData.staticIaJsons)) {
            return ringIaData.staticIaJsons.map(StaticIA_1.StaticIA.fromJson);
        }
        return [];
    }
    /** Retrieves true when IAItem is placed in a Kette (e.g. via IA-Editor) */
    isPlacedInKette() {
        var _a;
        return ((_a = this.localTransform) === null || _a === void 0 ? void 0 : _a.length) === 6;
    }
    /** Retrieves true when this article is a Öffnungssteg and has no uebermass */
    isOeffnungsSteg() {
        var _a;
        // 450'er böden, see EKE-9863
        // these böden have no "uebermass", but it's needed for snapping/placement!
        return ((_a = this.artNr) === null || _a === void 0 ? void 0 : _a.startsWith('450')) === true;
    }
    /*
     * check whetcher we would like to snap in a grid or not
     */
    isRasterIA() {
        var _a;
        if (this.artikeltyp &&
            [echain_shared_articles_1.IAArtikeltyp.Universalraststeg, echain_shared_articles_1.IAArtikeltyp.Rasttrennsteg, echain_shared_articles_1.IAArtikeltyp.KlemmRasttrennsteg].includes(this.artikeltyp)) {
            return true;
        }
        // TODO: EKE-10288 improve this check somehow..
        if ((_a = this.artNr) === null || _a === void 0 ? void 0 : _a.startsWith('RX'))
            return true;
        return false;
    }
    fitsInLink(linkUnion, tolerance = echain_shared_quantities_1.Length.mm(1)) {
        var _a, _b, _c;
        const clonedIA = this.clone();
        // if iaArtikeltyp does not exist, check KetteSerieRef with corresponding SerieId
        (_a = clonedIA.artikeltyp) !== null && _a !== void 0 ? _a : (clonedIA.artikeltyp = (_c = (_b = clonedIA.ketteSerieRef) === null || _b === void 0 ? void 0 : _b.find((ketteSerieRef) => { var _a; return ketteSerieRef.id === ((_a = linkUnion.SerieRef) === null || _a === void 0 ? void 0 : _a.Id); })) === null || _c === void 0 ? void 0 : _c.artikeltyp);
        // if still artikeltyp found return
        if (!clonedIA.artikeltyp)
            return false;
        // if no boden it should fit
        if (!clonedIA.isFachboden())
            return true;
        const linkSerieType = linkUnion.KetteSerieType;
        if (!linkSerieType)
            return false;
        switch (linkSerieType) {
            case echain_shared_articles_1.KetteSerieType.rxRohr:
                return true;
            case echain_shared_articles_1.KetteSerieType.default:
            case echain_shared_articles_1.KetteSerieType.eskin:
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe:
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
            case echain_shared_articles_1.KetteSerieType.rolEchain: {
                if (!linkUnion.Innenbreite || !clonedIA.breite) {
                    return true;
                }
                if (clonedIA.artikeltyp === echain_shared_articles_1.IAArtikeltyp.Einsteckboden) {
                    return (clonedIA.breite.mm <= (0, echain_shared_quantities_1.Q)(linkUnion.Innenbreite).mm + tolerance.mm &&
                        clonedIA.breite.mm >= (0, echain_shared_quantities_1.Q)(linkUnion.Innenbreite).mm - tolerance.mm);
                }
                return clonedIA.breite.mm <= (0, echain_shared_quantities_1.Q)(linkUnion.Innenbreite).mm + tolerance.mm;
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(linkSerieType);
        }
    }
}
exports.IA = IA;
//# sourceMappingURL=IA.js.map